var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5167 9.75065L22.6167 4.03398C21 3.10065 19 3.10065 17.3667 4.03398L7.48337 9.75065C5.8667 10.684 4.8667 12.4173 4.8667 14.3007V25.7007C4.8667 27.5673 5.8667 29.3006 7.48337 30.2507L17.3834 35.9673C19 36.9007 21 36.9007 22.6334 35.9673L32.5334 30.2507C34.15 29.3173 35.15 27.584 35.15 25.7007V14.3007C35.1334 12.4173 34.1334 10.7007 32.5167 9.75065ZM18.75 12.9173C18.75 12.234 19.3167 11.6673 20 11.6673C20.6834 11.6673 21.25 12.234 21.25 12.9173V21.6673C21.25 22.3507 20.6834 22.9173 20 22.9173C19.3167 22.9173 18.75 22.3507 18.75 21.6673V12.9173ZM21.5334 27.7173C21.45 27.9173 21.3334 28.1006 21.1834 28.2673C20.8667 28.584 20.45 28.7507 20 28.7507C19.7834 28.7507 19.5667 28.7007 19.3667 28.6173C19.15 28.534 18.9834 28.4173 18.8167 28.2673C18.6667 28.1006 18.55 27.9173 18.45 27.7173C18.3667 27.5173 18.3334 27.3006 18.3334 27.084C18.3334 26.6507 18.5 26.2173 18.8167 25.9007C18.9834 25.7507 19.15 25.634 19.3667 25.5506C19.9834 25.284 20.7167 25.434 21.1834 25.9007C21.3334 26.0673 21.45 26.234 21.5334 26.4507C21.6167 26.6507 21.6667 26.8673 21.6667 27.084C21.6667 27.3006 21.6167 27.5173 21.5334 27.7173Z",
    fill: "#ED1C00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoError);
export default __webpack_public_path__ + "static/media/info-error.0c067efa8273e7ff3f1d584a2e662823.svg";
export { ForwardRef as ReactComponent };